import * as PIXI from "pixi";

import Game from "./Game";
import Cs from "../utils/Cs";
import { ACTIONS, ActionType } from "./actions";
import Piou from "./Piou";
import Keyboard from "../utils/Keyboard";
import { convertToDisplayObjectToSprite } from "../utils/PixiAnimation";

const PIOU_SELECTION_GRAPHICS = new PIXI.Graphics()
  .beginFill(0xffffff)
  .drawCircle(0, -7, 10)
  .endFill()
  .beginHole()
  .drawCircle(0, -7, 9)
  .endHole();

const PIOU_ARROW_GRAPHICS = new PIXI.Graphics()
  .beginFill(0xffffff)
  .moveTo(0, -17)
  .lineTo(3, -22)
  .lineTo(-3, -22)
  .lineTo(0, -17)
  .endFill();

export default class ActionManager {
  game: Game;

  piouArrow: PIXI.Graphics = PIOU_ARROW_GRAPHICS;
  piouSelections: PIXI.DisplayObject[] = [];

  availableActions: number[] = [];

  selectedType: ActionType | null = null;

  constructor(game: Game) {
    this.game = game;

    this.game.app.ticker.add(this.update.bind(this));

    this.game.uiContainer.addChild(this.piouArrow);
    this.piouArrow.visible = false;

    this.availableActions = new Array(ACTIONS.length).fill(0);
    for (const action of this.game.lvlInfo.data.action) {
      if (action[1] === 0) continue;
      this.availableActions[action[0]] = action[1];
    }

    this.game.mouse.down(this.onClick.bind(this));
    Keyboard.down("KeyC", () => {
      for (let i = 0; i < ACTIONS.length; i++) {
        this.availableActions[i] = 100;
        this.game.emit("uiUpdate", "action");
      }
    });
  }

  update() {
    if (
      this.selectedType !== null &&
      this.availableActions[this.selectedType] > 0
    ) {
      const piou = this.getNearestPiou(
        this.game.mouse.position,
        this.selectedType
      );
      if (piou) {
        this.piouArrow.visible = true;
        this.piouArrow.x = piou.x;
        this.piouArrow.y = piou.y;
      } else {
        this.piouArrow.visible = false;
      }
    }

    if (this.game.paused) return;

    for (const gfx of [...this.piouSelections]) {
      if (gfx.alpha <= 0) {
        this.piouSelections.splice(this.piouSelections.indexOf(gfx), 1);
        this.game.uiContainer.removeChild(gfx);
        return;
      }
      gfx.alpha -= 0.2;
      gfx.scale.set(gfx.scale.x + 0.1);
    }
  }

  onClick(e: PIXI.InteractionEvent, pt: PIXI.Point) {
    if (
      this.selectedType !== null &&
      this.availableActions[this.selectedType] > 0
    ) {
      const piou = this.getNearestPiou(pt, this.selectedType);
      if (piou) {
        this.availableActions[this.selectedType]--;
        this.game.emit("uiUpdate", "action");
        const action = new ACTIONS[this.selectedType](piou);
        piou.currentAction = action;
        action.init();

        const gfx = PIOU_SELECTION_GRAPHICS.clone();
        // gfx.filters = [new PIXI.filters.GlowFilter()];
        gfx.x += piou.x;
        gfx.y += piou.y;
        this.game.uiContainer.addChild(gfx);
        this.piouSelections.push(gfx);
      }
    }
  }

  getNearestPiou(pt: PIXI.Point, checkSelectable: ActionType, maxDist = 10) {
    let nearestPiou: Piou | null = null;
    let nearestPiouDistance = maxDist;
    for (const piou of this.game.piouList) {
      const distance = Cs.getDist(piou.centerPosition, pt);
      if (
        distance < nearestPiouDistance &&
        piou.isSelectable(checkSelectable)
      ) {
        nearestPiouDistance = distance;
        nearestPiou = piou;
      }
    }
    return nearestPiou;
  }

  selectAction(type: ActionType) {
    this.selectedType = type;
  }
}
